import { isAxiosError } from 'axios';
import { en } from '../locale';

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    if (error.response?.status === 403) return en.common.insufficientRights;
    if (error.response?.status === 409) return en.common.conflictExists;
    const detail = error.response?.data as { title?: string; detail?: string } | undefined;
    return detail?.detail ?? detail?.title ?? fallback;
  }
  return fallback;
}
